import styled from 'styled-components';

export const AppContainer = styled.div`
    backface-visibility: hidden;
    height: 100vh;
`;
